export const isMobile = {
  Android: () => navigator.userAgent.match(/Android/i),
  AnyMobile: () => isMobileDevice()
};

export const isBrowser = {
  Chrome: () => navigator.userAgent.match(/Chrome/i),
};

function isMobileDevice() {
  const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  const isSmallScreen = window.innerWidth <= 768;

  return isMobile || isSmallScreen;
}
